import { z } from 'zod';

export const UserSchema = z.object({
  accessToken: z.string().or(z.null()),
  user: z.object({
    id: z.string().or(z.null()),
    name: z.string().or(z.null()),
    email: z.string().or(z.null()),
    role: z.string().or(z.null()),
  }),
});

export type User = z.infer<typeof UserSchema>;
